

import React from 'react';
import {useTranslation} from "react-i18next";
import Section from "../basic/layouts/section";
import BlogApi from "../api/blog_api";
import ButtonReadMoreComponent from "../button/read_more";

function SectionBlog(props) {

    const { t, i18n } = useTranslation()

    return (<div className={'mt-5'}>

        <div className="text-center">
            <div id={'whtat-todo__title-position'} className="p-5">
                <small className="text-secondary">
                    {t('nav.blog')}
                </small>

                <h2 className={'display-1'}>
                    {t('Latest posts')}
                </h2>

            </div>
        </div>

        <Section title={''} name={''} child={<div className={'rounded-5 bg- text-white1'}>

            <div className="container">
                <div className="d-flex flex-wrap justify-content-between align-items-start">

                    <BlogApi />

                    {/*{*/}
                    {/*    [...Array(6)].map((e, i) =>  <div className="col-md-4 col-12 p-2 position-relative">*/}
                    {/*        <div className="blog-post-cover border rounded-5">*/}
                    {/*            <img src="https://tehnomag.com/upload/catalog/product/5020/thumb/apple-iphone-14-plus-blue-a_63516ea26f734_650xr.png" alt="iphone" className={'img-fluid rounded-5'}/>*/}
                    {/*        </div>*/}
                    {/*        <h3 className={'text-dark p-1 position-absolute bottom-0 bg-light p-3 rounded-5'}>*/}
                    {/*            <a href="https://blog.lukyanchuk.com" className={'text-decoration-none text-dark display-6'}>*/}
                    {/*                /!*<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor"*!/*/}
                    {/*                /!*     className="bi bi-arrow-right" viewBox="0 0 16 16">*!/*/}
                    {/*                /!*    <path fill-rule="evenodd"*!/*/}
                    {/*                /!*          d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>*!/*/}
                    {/*                /!*</svg> *!/*/}
                    {/*                <text>Title blog post</text>*/}
                    {/*            </a>*/}
                    {/*        </h3>*/}
                    {/*    </div>)*/}
                    {/*}*/}

                </div>
            </div>

        </div>} link={'/'} linkName={''}/>

        <div className="text-end p-5">
            <ButtonReadMoreComponent
                url={'/blog'}
                label={'title.read.more'}
                class={'text-decoration-none text-dark display-5'}
                size={52}
            />
            {/*<a href="https://blog.y-l.pro" className={'text-decoration-none text-dark display-5'}>*/}
            {/*    <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor"*/}
            {/*         className="bi bi-arrow-right" viewBox="0 0 16 16">*/}
            {/*        <path fill-rule="evenodd"*/}
            {/*              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>*/}
            {/*    </svg> <b>read more</b>*/}
            {/*</a>*/}
        </div>

    </div>);
}

export default SectionBlog;
